export enum LoopMode {
    Off = 'off',
    One = 'one',
    All = 'all',
}

/**
 * Which loop cycle a piece of content supports. The value determines both
 * whether the loop button is shown and which modes the button cycles through.
 */
export enum LoopCapability {
    /**
     * Looping is not available; no loop button is shown (e.g. soundscapes,
     * clinical, mindshift, dailies, trailers).
     */
    Unsupported = 'unsupported',
    /**
     * Only Repeat-One is reachable — two-state cycle: Off → One → Off. Used by
     * single tracks and DTC courses/series (play-once, per EVE-11927).
     */
    RepeatOneOnly = 'repeatOneOnly',
    /**
     * Both Repeat-All and Repeat-One are reachable — three-state cycle:
     * Off → All → One → Off. Used by non-DTC multi-track playlists — music
     * albums and sleep-story playlists (EVE-11932).
     */
    RepeatAllAndOne = 'repeatAllAndOne',
}
